(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  function parseVariantsFromPicker(variantSelectsEl) {
    const scripts = $$('script[type="application/json"]', variantSelectsEl);

    for (const s of scripts) {
      const txt = (s.textContent || "").trim();
      if (!txt) continue;

      try {
        const data = JSON.parse(txt);

        if (Array.isArray(data) && data.length && data[0]?.id) return data;
        if (data?.variants && Array.isArray(data.variants)) return data.variants;
      } catch (e) {}
    }
    return null;
  }

  function getSectionIdFromVariantSelects(variantSelectsEl) {
    return (
      variantSelectsEl?.getAttribute("data-section") ||
      variantSelectsEl?.id?.replace("variant-selects-", "") ||
      null
    );
  }

  function getFormFromVariantSelects(variantSelectsEl) {
    const sample = $('input[type="radio"][form], select[form]', variantSelectsEl);
    const formId = sample?.getAttribute("form");
    if (formId) return document.getElementById(formId);

    return (
      variantSelectsEl.closest("product-form")?.querySelector('form[action^="/cart/add"]') ||
      $('form[action^="/cart/add"]')
    );
  }

  function getSubmitButton(sectionId, formEl) {
    if (sectionId) {
      const btn = document.getElementById(`ProductSubmitButton-${sectionId}`);
      if (btn) return btn;
    }
    return formEl?.querySelector('button[name="add"], button[type="submit"], .product-form__submit');
  }

  function getSelected(variantSelectsEl, name) {
    const checked = $(`input[name="${CSS.escape(name)}"]:checked`, variantSelectsEl);
    if (checked) return checked.value;

    const sel = $(`select[name="${CSS.escape(name)}"]`, variantSelectsEl);
    if (sel) return sel.value;

    return null;
  }

  function computeRingVariantId(variantSelectsEl, ringVariants) {
    const color = getSelected(variantSelectsEl, "options[Color]");
    const size = getSelected(variantSelectsEl, "options[Size]");
    if (!color || !size || !ringVariants) return null;

    const match = ringVariants.find((v) => v.option1 === color && v.option2 === size);
    return match?.id || null;
  }

  function removeDisabledForATC(idInput, submitBtn) {
    if (idInput) idInput.removeAttribute("disabled");
    if (submitBtn) submitBtn.removeAttribute("disabled");
  }

  function setFormVariantId(idInput, submitBtn, variantId) {
    if (!idInput || !variantId) return;
    idInput.value = String(variantId);
    removeDisabledForATC(idInput, submitBtn);

    // Let any theme listeners react
    idInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  document.addEventListener("DOMContentLoaded", () => {
    const toggleWrap = $('[data-sizing-kit-toggle]');
    if (!toggleWrap) return;

    const toggleBtn = $(".sizing-kit-toggle__btn", toggleWrap);
    const kitVariantId = toggleWrap.getAttribute("data-sizing-kit-variant-id");
    if (!toggleBtn || !kitVariantId) return;

    // Find the variant picker this toggle belongs to
    const variantSelectsEl = toggleWrap.closest("variant-selects");
    if (!variantSelectsEl) return;

    const sectionId = getSectionIdFromVariantSelects(variantSelectsEl);
    const formEl = getFormFromVariantSelects(variantSelectsEl);
    if (!formEl) return;

    const idInput = formEl.querySelector('input[name="id"]');
    const submitBtn = getSubmitButton(sectionId, formEl);

    // Ring variants from inline JSON in the picker
    const ringVariants = parseVariantsFromPicker(variantSelectsEl);

    // IMPORTANT: default should be "size" mode (normal ring variant)
    // Your accordion script dispatches velia:kitmode true/false.
    let kitMode = false;

    function applyModeDeferred() {
      requestAnimationFrame(applyMode);
      setTimeout(applyMode, 0);
    }

    function applyMode() {
      if (kitMode) {
        // Force kit variant id
        setFormVariantId(idInput, submitBtn, kitVariantId);
      } else {
        // Restore ring variant id based on current selections
        const ringVariantId = computeRingVariantId(variantSelectsEl, ringVariants);
        if (ringVariantId) setFormVariantId(idInput, submitBtn, ringVariantId);
      }
    }

    // Listen for your accordion events
    variantSelectsEl.addEventListener("velia:kitmode", (e) => {
      kitMode = !!e.detail?.kitMode;
      applyModeDeferred();
    });

    // Whenever options change, if we're NOT in kit mode we keep ring variant correct,
    // if we ARE in kit mode we keep forcing kit variant id.
    variantSelectsEl.addEventListener("change", applyModeDeferred);
    document.addEventListener("variant:change", () => {
      applyModeDeferred();
    });

    // Safety: right before submit, ensure correct id
    formEl.addEventListener(
      "submit",
      () => {
        applyMode();
      },
      true
    );

    // Initial sync
    applyMode();
  });
})();

/* Accordion script stays the same as you already have */
(() => {
  const $ = (s, r = document) => r.querySelector(s);

  function setPanelOpen(itemEl, open) {
    const btn = $(".velia-acc__btn", itemEl);
    const panel = $(".velia-acc__panel", itemEl);
    const radio = $(".velia-acc__radio", itemEl);

    if (!btn || !panel) return;

    btn.setAttribute("aria-expanded", open ? "true" : "false");

    panel.hidden = false;
    const content = panel.firstElementChild;
    const h = content ? content.scrollHeight : panel.scrollHeight;

    if (open) {
      panel.style.maxHeight = h + "px";
      if (radio) radio.classList.add("is-on");
    } else {
      panel.style.maxHeight = "0px";
      if (radio) radio.classList.remove("is-on");
      panel.addEventListener(
        "transitionend",
        () => {
          if (btn.getAttribute("aria-expanded") === "false") panel.hidden = true;
        },
        { once: true }
      );
    }
  }

  function initAcc(root) {
    const kitItem = $('[data-acc-item="kit"]', root);
    const sizeItem = $('[data-acc-item="size"]', root);
    if (!kitItem || !sizeItem) return;

    // Default: SIZE open (kitMode false)
    setPanelOpen(sizeItem, true);
    setPanelOpen(kitItem, false);

    $(".velia-acc__btn", kitItem)?.addEventListener("click", () => {
      setPanelOpen(kitItem, true);
      setPanelOpen(sizeItem, false);
      root.dispatchEvent(new CustomEvent("velia:kitmode", { bubbles: true, detail: { kitMode: true } }));
    });

    $(".velia-acc__btn", sizeItem)?.addEventListener("click", () => {
      setPanelOpen(sizeItem, true);
      setPanelOpen(kitItem, false);
      root.dispatchEvent(new CustomEvent("velia:kitmode", { bubbles: true, detail: { kitMode: false } }));
    });

    root.VeliaAccordion = {
      setKitMode(isKit) {
        setPanelOpen(kitItem, !!isKit);
        setPanelOpen(sizeItem, !isKit);
      },
    };
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-velia-acc]").forEach(initAcc);
  });
})();